import Api from './api.service'

export default {
  create (object) {
    return Api().post('testimonial/create', object)
  },
  update (object) {
    return Api().put('testimonial/edit/' + object.id, object.object)
  },
  list (filter) {
    return Api().get('testimonial/get', { params: filter })
  },
  get (id) {
    return Api().get('testimonial/get/' + id)
  }
}